import React, { FC, Fragment } from 'react';
import { Button } from '@cokitchen/cokitchen-components';
import { useNavigate } from 'react-router-dom';
import PaymentStatusTag from 'components/base/payment-status-tag';
import { MAIN_STORE_ROUTE_KEYS } from 'utils/constants';
import { ENUM_PAYMENT_STATUS } from 'models/common.model';
import moment from 'moment';
import { formatCurrency } from 'utils/functions';
import usePaymentTrackerContext from 'contexts/payment-tracker.context';
import { PaymentRequestDetailType } from 'models/payment-tracker.model';

type Props = {
  request: PaymentRequestDetailType;
};

const PaymentCard: FC<Props> = ({ request }) => {
  const orderCode = request?.code || 'N/A';
  const { setPaymentItemToEdit } = usePaymentTrackerContext();

  const navigate = useNavigate();

  const viewPayment = () => {
    setPaymentItemToEdit(request);
    navigate(`${MAIN_STORE_ROUTE_KEYS.PAYMNET_TRACKER}/update/${request.id}`);
  };

  return (
    <Fragment>
      <div
        onClick={() => viewPayment()}
        className='border hover:bg-gray-11 border-gray-13 rounded-lg flex flex-col py-2 w-full cursor-pointer'>
        <div className='grow'>
          <div className='flex border-b border-[#ECEDEF] pb-2 items-center gap-2 flex-wrap justify-between px-3'>
            <h4 className='font-medium text-base cursor-pointer'>#{orderCode}</h4>
            <PaymentStatusTag status={request.status as ENUM_PAYMENT_STATUS} />
          </div>

          <div className='p-3 text-sm flex justify-between items-center'>
            <p>{request?.vendor?.name}</p>
            <p>{formatCurrency(request.amount)}</p>
          </div>
          <p className='pl-3 text-gray-5'>{request.request_item.ingredient.name}</p>
        </div>
        <div className='flex border-t border-[#ECEDEF] pb-2 text-xs items-center gap-2 flex-wrap justify-between mx-3 pt-2'>
          <p>Payment due {moment(request?.payment_due_date)?.format('Do MMM, YYYY')}</p>
          <Button className='text-xs' color='primary' variant='link' onClick={() => viewPayment()}>
            View
          </Button>
        </div>
      </div>
    </Fragment>
  );
};

export default PaymentCard;
